(async () => {

  if (!customElements.get('product-tabs-swiper')) {

    let { default: Swiper, Navigation } = await import("swiper");

    Swiper.use([
      Navigation
    ]);

    class TabsSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-product-tabs-slider]');
        this.swiperOptions = {
          threshold: 10
        };

        // Check if we have extra options on the HTML
        if (this.swiperElement && this.swiperElement.dataset && this.swiperElement.dataset.options) {
          const jsonOptions = JSON.parse(this.swiperElement.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperElement.update();
            if(this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.swiperElement.update();
            if (this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiperElement.update();
            if (this.swiperOptions.navigation) {
              this.swiperElement.navigation.init();
              this.swiperElement.navigation.update();
            }
            this.handleBlockSelect(event);
          });

        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect(event) {
        
        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) { return; }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if(this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiperElement.slideTo(swipeToSlideIndex, 1000);

      } 
    }
    window.TabsSlider = TabsSlider;
    customElements.define('product-tabs-swiper', TabsSlider);
  }

})();